import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { Toaster } from 'sonner';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import App from './App.tsx';
import { TooltipProvider } from './components/ui/tooltip.tsx';
import './config/locale.ts';
import i18n from './config/locale.ts';
import { CartProvider } from './contexts/CartContext.tsx';
import './index.css';
import { asyncStoragePersister, queryClient } from './services/api.ts';

const rootElement = document.getElementById('root')!;
i18n.on('languageChanged', (lng) => {
	document.documentElement.lang = lng;
	document.documentElement.dir = i18n.dir(lng);
	document.documentElement.setAttribute('data-locale', lng);
	document.documentElement.setAttribute('data-locale-dir', i18n.dir(lng));
});
document.documentElement.lang = i18n.language;
document.documentElement.dir = i18n.dir(i18n.language);
document.documentElement.setAttribute('data-locale', i18n.language);
document.documentElement.setAttribute(
	'data-locale-dir',
	i18n.dir(i18n.language)
);
const root = createRoot(rootElement);

// i18n.changeLanguage('en');

root.render(
	<StrictMode>
		<Toaster />
		<TooltipProvider>
			<CartProvider>
				<PersistQueryClientProvider
					client={queryClient}
					persistOptions={{
						persister: asyncStoragePersister,
					}}>
					<BrowserRouter>
						<QueryParamProvider adapter={ReactRouter6Adapter}>
							<App />
						</QueryParamProvider>
					</BrowserRouter>
				</PersistQueryClientProvider>
			</CartProvider>
		</TooltipProvider>
	</StrictMode>
);
